// useEffect, co se neprovede na 1. render, ale jen při změně dep array

import { useEffect, useRef } from "react";

type Callback = (() => void) | (() => () => void);

export function useDelayedEffect(
  callback: Callback,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dependencyArray: any[] = []
) {
  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    // eslint-disable-next-line consistent-return
    return callback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencyArray);
}

export default useDelayedEffect;
